//
// Module for Financial Institution template
//
rs.module("system_/configuration/financialinstitutions/financialinstitutionentity",

    ["common/visibility"],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, codeValues) {

            var financialInstitutionFields = $.js(jsSelectors.financialInstitutionFields);

            var abaNumberGrouping = financialInstitutionFields.js(jsSelectors.abaNumberGrouping);
            var abaNumberInput = abaNumberGrouping.js(jsSelectors.abaNumber);

            var internationalIdentifierGrouping = financialInstitutionFields.js(jsSelectors.internationalIdentifierGrouping);
            var internationalIdentifierInput = internationalIdentifierGrouping.js(jsSelectors.internationalIdentifier);

            var feinInput = financialInstitutionFields.js(jsSelectors.fein);
            var typeSelect = financialInstitutionFields.js(jsSelectors.type);

            // Control Bank Identifier and FEIN based on International selection
            typeSelect.change(function () {
                var internationalSelected = typeSelect.val() == codeValues.international;

                feinInput.prop('disabled', internationalSelected);

                if (internationalSelected) {
                    abaNumberInput.val('').clearErrors();
                    feinInput.val('').clearErrors();

                    visibility.hide(abaNumberGrouping);
                    visibility.show(internationalIdentifierGrouping);
                } else {
                    internationalIdentifierInput.val('').clearErrors();

                    visibility.show(abaNumberGrouping);
                    visibility.hide(internationalIdentifierGrouping);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);